<template>
	<div class="the-custom-search-filter">
		<div class="the-csf-start">
			<div class="the-filter-box">
				<button
					type="button"
					variant="primary"
					class="the-filter-btn"
					@click="filterPopup()"
				>
					<span class="mr-2"
						><svg
							xmlns="http://www.w3.org/2000/svg"
							width="18"
							height="18"
							viewBox="0 0 18 18"
							fill="none"
						>
							<path
								d="M0 15C0 15.55 0.45 16 1 16H6V14H1C0.45 14 0 14.45 0 15ZM0 3C0 3.55 0.45 4 1 4H10V2H1C0.45 2 0 2.45 0 3ZM10 17V16H17C17.55 16 18 15.55 18 15C18 14.45 17.55 14 17 14H10V13C10 12.45 9.55 12 9 12C8.45 12 8 12.45 8 13V17C8 17.55 8.45 18 9 18C9.55 18 10 17.55 10 17ZM4 7V8H1C0.45 8 0 8.45 0 9C0 9.55 0.45 10 1 10H4V11C4 11.55 4.45 12 5 12C5.55 12 6 11.55 6 11V7C6 6.45 5.55 6 5 6C4.45 6 4 6.45 4 7ZM18 9C18 8.45 17.55 8 17 8H8V10H17C17.55 10 18 9.55 18 9ZM13 6C13.55 6 14 5.55 14 5V4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2H14V1C14 0.45 13.55 0 13 0C12.45 0 12 0.45 12 1V5C12 5.55 12.45 6 13 6Z"
								fill="#808890"
							/></svg
					></span>
					Bộ lọc
				</button>
			</div>
			<div class="the-input-box">
				<slot name="input-icon">
					<svg
						width="28"
						height="28"
						viewBox="0 0 28 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						class="the-search-box-icon"
					>
						<path
							d="M12.5322 19.0332C13.9297 19.0332 15.2393 18.6113 16.3291 17.8906L20.1787 21.749C20.4336 21.9951 20.7588 22.1182 21.1104 22.1182C21.8398 22.1182 22.376 21.5469 22.376 20.8262C22.376 20.4922 22.2617 20.167 22.0156 19.9209L18.1924 16.0801C18.9834 14.9551 19.4492 13.5928 19.4492 12.1162C19.4492 8.31055 16.3379 5.19922 12.5322 5.19922C8.73535 5.19922 5.61523 8.31055 5.61523 12.1162C5.61523 15.9219 8.72656 19.0332 12.5322 19.0332ZM12.5322 17.1875C9.74609 17.1875 7.46094 14.9023 7.46094 12.1162C7.46094 9.33008 9.74609 7.04492 12.5322 7.04492C15.3184 7.04492 17.6035 9.33008 17.6035 12.1162C17.6035 14.9023 15.3184 17.1875 12.5322 17.1875Z"
							fill="#666666"
						/>
					</svg>
				</slot>

				<input
					type="text"
					class="the-search-input"
					placeholder="Tìm kiếm..."
					v-model="textSearch"
					@change="handleChange"
				/>
			</div>
		</div>

		<LayoutPopup id="filter-popup">
			<template #title></template>
			<template #content>
				<p class="text-center fz-20">
					Bạn thân mến! Vui lòng tự code chỗ này nhé!
				</p>
			</template>
			<template #control-right>
				<BaseButton
					@click="hidePopup('selectLocation')"
					size="sm"
					variant="outline"
				>
					Cancel
				</BaseButton>
			</template>
		</LayoutPopup>
	</div>
</template>

<script>
export default {
	name: "BaseSearchbar",
	data() {
		return {}
	},
	methods: {
		filterPopup() {
			this.showPopup("filter-popup");
		},

		handleChange() {
			this.$emit("search", this.textSearch)
		}
	},
};
</script>

<style scoped lang="scss">
.the-custom-search-filter {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 64px;
	padding: 10px 24px;
	top: 64px;
	right: 0;
	position: absolute;
	z-index: 999;
	background: #fff;
	width: calc(100% - 300px);
}

.the-csf-start,
.the-csf-end {
	display: flex;
	align-items: center;
}

.the-filter-btn {
	padding: 12px;
	background: #f2f2f2;
	margin-right: 10px;
	border-radius: 4px;
}

.the-input-box {
	background: #f2f2f2;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	width: 280px;
	height: 44px;
	border-radius: 4px;

	.the-search-box-icon {
		margin: 12px;
	}

	.the-search-input {
		background: #f2f2f2;
	}
}

@media screen and (max-width: 1140px) {
	.the-custom-search-filter {
			width: calc(100% - 80px);
	}
}
</style>